import {ICrudStore} from 'Store'
import License from './Model'
import {action, observable} from 'mobx'
import {api} from 'helpers/Api'

export default class {
  @observable data: License[] = []
  @observable loaded: boolean = false

  read(id?: number) {
    if (id) return api.get('devices' + id)
    return api.get('devices').then(value => this.set)
  }

  @action
  private set = (values: License[]) => {
    this.data = values.map(value => new License(value))
    this.loaded = true
    return this.data
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Licenses/Store.ts